<template>
  <div>
    <Modal
      ref="modal"
      v-model="showModal"
      :width="500"
      :footer-hide="true"
      :closable="false"
    >
      <slot name="header"></slot>
      <div v-if="showModal">
        <div class="modal-title">课程详情</div>
        <div class="modal-info">
          {{ courseInfo.classroomName }}
          <slot name="providerName" :row="courseInfo"></slot>
        </div>
        <div class="modal-info">
          <span>{{ courseInfo.timeDesc }}</span>
          <span v-if="courseInfo.arrangingRuleBo">{{
            courseInfo.arrangingRuleBo.ruleType | ruleTypeCh
          }}</span>
        </div>
        <div class="modal-info">
          <slot name="class-info-date" :row="courseInfo"></slot>
        </div>
        <div class="modal-info">
          <span>{{ courseInfo.teacherDesc }}</span>
          <span>{{ courseInfo.placeName }}</span>
        </div>
        <div v-if="showDetailBtn" class="modal-info modal-btn">
          <slot name="update-class-date" :row="courseInfo"></slot>
          <Button
            type="primary"
            @click="handleShowTimeTable"
          >查看课表明细</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  filters: {
    // 排课类型
    ruleTypeCh(ruleType) {
      let str = '';
      switch (Number(ruleType)) {
        case 1:
          str = '每周循环';
          break;
        case 2:
          str = '指定上课周';
          break;
        default:
          break;
      }
      return str;
    }
  },
  props: {
    classroomId: {
      type: String,
      default: ''
    },
    // 是否展示查询课表的按钮
    showDetailBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showModal: false,
      courseInfo: {} // 课班信息

    };
  },
  methods: {
    async open() {
      await this.getCourseBaseDetails();
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    handleShowTimeTable() {
      this.$emit('timeTableOpen');
      this.close();
    },
    // 获取课班详情基础信息
    async getCourseBaseDetails() {
      const params = {
        classroomId: this.classroomId
      };
      const res = await courseSchedulCenter.getClassPartitionDetails(params);
      if (res.status === 200) {
        this.courseInfo = res.message;
      }
    }
  },

};
</script>
<style lang="scss" scoped>
.modal-title {
  font-size: 16px;
  font-weight: bold;
}
.modal-info {
  margin-top: 16px;
  span {
    margin-right: 16px;
  }
}
.modal-btn {
  text-align: right;
}
</style>
